//@ts-nocheck
/* 
 *  This file shared.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

import { ConfirmationService } from 'primeng/api'; 
import * as _ from 'lodash';

import { HttpService } from './http-service';
import { environment } from '../../../environments/environment';
import { IMenuModel } from 'src/app/modules/product-management/setup/page-access-right/page-access-right.model';
import { ConfigurationService } from './configuration.service';
import * as moment from 'moment';
import {  ISuperUser } from 'src/app/modules/product-management/setup/user/user.model';

const companyLogo = 'assets/images/LogoGreen.svg';
// const companyBgImage = 'assets/images/login-bg-t20.png';
const companyBgImage = 'assets/images/Loginpreview.svg';
// const companyBgImage = 'assets/images/PrideLoginPreview.svg'; //changes done by Sakshi after discussed with Magnum Sir
const companyHeading = 'HROne'; //changes done by Sakshi after discussed with Magnum Sir
const companySubHeading = 'Enabling happier workplaces';
const companyFontColor = "#000000";
const favicon = "assets/images/dynamic_images/favicon_hrone.ico";
const flashLoader = "/assets/images/init-loader-1.svg";
const title = "HROne V5";
const companyLogoGT = "assets/images/dynamic_images/demo.jpg";
const companyBgImageGT = "assets/images/Loginpreview.svg";
const companyHeadingGT = "";
const companySubHeadingGT = "";
const companyFontColorGT = "#000000";
const faviconGT = "assets/images/dynamic_images/favicon.ico";
const flashLoaderGT = "assets/images/dynamic_images/loader-2.svg";
const titleGT = 'HRMS';
const placeholders = {
  ph1: '/assets/images/image-placeholder.jpg',
  ph2: './assets/images/employee.png',
  ph3: './assets/images/no-image.png'
};

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  profile: string;
  phImages = placeholders;
  matcher = new MyErrorStateMatcher();
  whiteLabels = {};
  confirmDialogData = {
    message: 'All data will be lost.',
    header: 'Do you want to close the window ?',
  };
  companyDetails = {
    companyLogo: this._config.configData.isDeployOnGT ? companyLogoGT : companyLogo,
    companyBgImage: this._config.configData.isDeployOnGT ? companyBgImageGT : companyBgImage,
    companyHeading: this._config.configData.isDeployOnGT ? companyHeadingGT : companyHeading,
    companySubHeading: this._config.configData.isDeployOnGT ? companySubHeadingGT : companySubHeading,
    companyFontColor: this._config.configData.isDeployOnGT ? companyFontColorGT : companyFontColor,
    companyLink: null,
    favicon: this._config.configData.isDeployOnGT ? faviconGT : favicon,
    title: this._config.configData.isDeployOnGT ? titleGT : title,
    flashLoader: !this._config.configData.isDeployOnGT ? flashLoader : flashLoaderGT
  };
  supportUserInfo = null;
  superUserLogOnDetails: ISuperUser;
  superUserMenuList: IMenuModel[] = [];


  /* ----- validation msg from requirement team ------ */
  public validationMessages = {
    hours: 'Only one digit is allowed after decimal',
    required: 'This field should not be left blank',
    numericOnly: 'Please enter only numeric digits.',
    numericDecimal: 'Please enter decimal numeric digits.',
    alphabetOnly: 'Please enter alphabets only.',
    alphaNumericOnly: 'Please enter only alphanumeric characters',
    allowedCharacters: "a-z, A-Z, 0-9 and (_ @ # $ % & () *.', - ? / : ; ! |) characters are allowed",
    blankSpace: 'Blank spaces are not allowed.',
    spaceNotAllowed: 'Space is not allowed',
    zeroOnlyNotAllowed: 'Zero is not allowed',
    maxLength: 'The maximum character limit is',
    minLength: 'The minimum character limit is',
    maxNumberLength: 'The maximum value allowed is',
    minNumberLength: 'The minimum value allowed is',
    maxLength20: 'Maximum 20 characters are allowed',
    duplicate: 'This code series already exists. Please select a new one and try again.',
    invalidEmail: 'This is not a valid email. Please enter a valid one and try again.',
    invalidWebsite: 'This is not a valid website. Please enter a valid one and try again.',
    validDate: 'This is not a valid date. Please enter a valid date and try again.',
    invalidTime: 'This is not a valid time. Please enter a valid time and try again.',
    numericOrDecimal: 'Invalid input', //'This is not a valid number.Please enter a valid one and try again.', changed after disccus with meghna bug id ---- 30108
    parAccessDenied: "You do not have permission. Please contact your administrator.",
    parView: "You do not have permission to view. Please contact your administrator.",
    parAdd: "You do not have permission to add. Please contact your administrator.",
    parEdit: "You do not have permission to edit. Please contact your administrator.",
    parUpdate: "You do not have permission to update. Please contact your administrator.",
    parDelete: "You do not have permission to delete. Please contact your administrator.",
    parRemove: "You do not have permission to remove. Please contact your administrator.",
    parInactivate: "You do not have permission to inactivate. Please contact your administrator.",
    pan: 'This is not a valid PAN number.',
    passport: 'This is not a valid passport no. Please enter a valid one and try again.',
    aadhar: 'This is not a valid aadhar card number. Please enter a valid one and try again.',
    autoComplete: 'This is not a valid input. Please search a valid one.',
    lessFromDate: 'This date cannot be less than from date.',
    lessStartDate: 'This date cannot be less than start date.',
    valueGreaterThan: 'The value should be greater than',
    invalidRange: 'Duration of date search should be 90 days',
    bothDate: 'Please select both From and To date ',
    SSOIdRegx: 'a-z, A-Z, 0-9 and (_ @ . -) characters are allowed',
    paytmWallet: 'This is not a valid wallet id. Please enter a valid one and try again',
    ipAddressInvalid: 'please enter valid Ip address',
    isValidUrl: 'please enter valid url',
    allowedCharactersWithApostrophe: "a-z, A-Z, 0-9 and (_ @ # $ % & () *., - ? / : ; ! | ') characters are allowed",
    specialCharacterValidation:"Only a-z, A-Z, 0-9 and (, _ -) special characters are allowed"
  };
  domainCode: any;
  /* ----- */

  constructor(
    public _httpService: HttpService,
    public _confirmDialog: ConfirmationService,
    public _config: ConfigurationService
  ) { }

  compareMultiselectFn(a, b) {
    return a && b && a.id === b.id;
  }

  compareMultiselectFn2(a, b) {
    return a && b && a.Id === b.Id;
  }

  compareMultiselectFn3(a, b) {
    return a && b && a.Key === b.Key;
  }

  compareMultiselectFn4(a, b) {
    return a && b && a.key === b.key;
  }

  compareMultiselectFn5(a, b) {
    return a && b && a === b;
  }

  compareMultiselect(a, b) {
    return a && b && a.key === b.key;
  }

  compareMultiselectPlain(a, b) {
    return a && b && a === b;
  }
 

  // remove new line from string
  removeNewLine(str: string) {
    const rstr =
      str.replace(/[\r\n\x0B\x0C\u0085\u2028\u2029]+/g, " ");
    return rstr ? rstr : '';
  }

  getAppVersion() {
    this._httpService.GetWithoutHeader('/api/Default/ApplicationVersion').subscribe((response: any) => {
      if (response && response.length) {
        const localV = localStorage.getItem('versionId');
        localStorage.setItem('versionId', response[0].versionId);
        if (localV != response[0].versionId) {
          location.reload();
        }
      }
    });
  }

  getDomain(): void {
    this._httpService.Get('/api/CustomerOverview/DomainCode/'+(this.superUserLogOnDetails.superUserId)).subscribe(response => {
      this.domainCode = response
    })
  }

  getComapanyDetails(domainCode) {
    this.companyDetails = {
      companyLogo: null,
      companyBgImage: null,
      companyHeading: null,
      companySubHeading: null,
      companyFontColor: null,
      companyLink: null,
      favicon: favicon,
      title: title,
      flashLoader: flashLoader
    };
    this._httpService.GetWithoutHeader('/api/Default/' + domainCode).subscribe((response: any) => {
      if (response && response.fileVirtualPath) {
        this.companyDetails.companyLogo = response.fileVirtualPath;
      } else {
        this.companyDetails.companyLogo = this._config.configData.isDeployOnGT ? companyLogoGT : companyLogo;
      }
      if (response && response.enterpriseBackgroundEntity && response.enterpriseBackgroundEntity.backgroundHeading) {
        this.companyDetails.companyHeading = response.enterpriseBackgroundEntity.backgroundHeading;
      } else {
        this.companyDetails.companyHeading = this._config.configData.isDeployOnGT ? companyHeadingGT : companyHeading;
      }
      if (response && response.enterpriseBackgroundEntity && response.enterpriseBackgroundEntity.backgroundSubheading) {
        this.companyDetails.companySubHeading = response.enterpriseBackgroundEntity.backgroundSubheading;
      } else {
        this.companyDetails.companySubHeading = this._config.configData.isDeployOnGT ? companySubHeadingGT : companySubHeading;
      }
      if (response && response.enterpriseBackgroundEntity && response.enterpriseBackgroundEntity.backgroundFontColor) {
        this.companyDetails.companyFontColor = response.enterpriseBackgroundEntity.backgroundFontColor;
      } else {
        this.companyDetails.companyFontColor = companyFontColor;
      }
      if (response && response.enterpriseBackgroundEntity && response.enterpriseBackgroundEntity.enterprisePath) {
        this.companyDetails.companyLink = response.enterpriseBackgroundEntity.enterprisePath;
      } else {
        this.companyDetails.companyLink = null;
      }
      if (response && response.enterpriseBackgroundEntity && response.enterpriseBackgroundEntity.backgroundImageVirtualPath) {
        this.companyDetails.companyBgImage = response.enterpriseBackgroundEntity.backgroundImageVirtualPath;
      } else {
        this.companyDetails.companyBgImage = this._config.configData.isDeployOnGT ? companyBgImageGT : companyBgImage;
      }

    }, error => {
      this.getDefaultCompDetails();
    });
  }

  getDefaultCompDetails() {
    this.companyDetails = {
      companyLogo: this._config.configData.isDeployOnGT ? companyLogoGT : companyLogo,
      companyBgImage: this._config.configData.isDeployOnGT ? companyBgImageGT : companyBgImage,
      companyHeading: this._config.configData.isDeployOnGT ? companyHeadingGT : companyHeading,
      companySubHeading: this._config.configData.isDeployOnGT ? companySubHeadingGT : companySubHeading,
      companyFontColor: this._config.configData.isDeployOnGT ? companyFontColorGT : companyFontColor,
      companyLink: null,
      favicon: this._config.configData.isDeployOnGT ? faviconGT : favicon,
      title: this._config.configData.isDeployOnGT ? titleGT : title,
      flashLoader: this._config.configData.isDeployOnGT ? flashLoaderGT : flashLoader
    };
  }

  getAccessRightsAsPerMenuId(menuId): boolean{
    return Boolean(this.superUserMenuList.find(item=>item.menuId === menuId));
    }

  stopPropagation(event) {
    try { event.stopPropagation(); } catch (err) { }
  }
  // get difference b/w two dates
checkDate(fromDate: Date, toDate: Date) {
  const fD = new Date(fromDate);
  const tD = new Date(toDate);
  const a = moment([fD.getFullYear(), (fD.getMonth()), fD.getDate()]);
  const b = moment([tD.getFullYear(), (tD.getMonth()), tD.getDate()]);
  // console.log(a.diff(b, 'days')); provide in negative   -90, -1
  console.log(b.diff(a, 'days'));  // provide in positive +90, +1
  return (90 >= (b.diff(a, 'days'))) ? true : false;
}

}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    // const isSubmitted = form;
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

}
